import { render, staticRenderFns } from "./SelectInput.vue?vue&type=template&id=22ba020d"
import script from "./SelectInput.vue?vue&type=script&lang=js"
export * from "./SelectInput.vue?vue&type=script&lang=js"
import style0 from "./SelectInput.vue?vue&type=style&index=0&id=22ba020d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports